/* src/app/cardholders/cardholder-adjustments/cardholder-adjustments.component.css */
/*# sourceMappingURL=cardholder-adjustments.component.css.map */
